import { FusionError } from '@fusion-advantage/backcompat'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AppThunk } from './appStore'
import { pushLogEntry } from './logSlice'
import { resetAppFormState } from './actions'

export enum DispatchableFormErrorType {
	DbError = 'dbError'
}

export interface ErrorSliceState {
	formHasDispatched: {
		[k in DispatchableFormErrorType]: boolean
	}
}

const initialState: ErrorSliceState = {
	formHasDispatched: {
		dbError: false,
	}
}

const errorSlice = createSlice({
	name: 'error',
	initialState,
	reducers: {
		setFormErrorHasDispatched(state, action: PayloadAction<DispatchableFormErrorType>) {
			state.formHasDispatched[action.payload] = true
		}
	},
	extraReducers: (builder) => {
		builder.addCase(resetAppFormState, (state, action) => {
			return {
				...state,
				formHasDispatched: {
					...initialState.formHasDispatched,
				}
			}
		})
	}
})

export const { setFormErrorHasDispatched } = errorSlice.actions
export default errorSlice.reducer

export interface AppErrorArgs {
	err: FusionError
	type?: DispatchableFormErrorType
	suppressDebugger?: boolean
	suppressAlert?: boolean
	alertMessage?: string
	suppressGeneralLog?: boolean
}

export const appError = ({err, type, suppressDebugger, suppressAlert, alertMessage, suppressGeneralLog}: AppErrorArgs): AppThunk<Promise<void>> => {
	// executing these synchronously on action create should provide
	// better stack traces than firing it off into the async stratosphere
	console.error(err)
	if(!suppressDebugger) {
		debugger
	}
	return async (dispatch, getState) => {
		dispatch(pushLogEntry(`[${err.area} ${err.name}] ${err.message}`))
		if(type) {
			// suppress mutliple errors of the same "type"
			// so dan and the user aren't bombarded
			if(getState().error.formHasDispatched[type]) {
				return
			}
			dispatch(setFormErrorHasDispatched(type))
		}
		if(!suppressAlert) {
			alert(alertMessage ?? `Sorry, an unexpected error occurred.  If you need assistance please contact support. [${err.area} ${err.name}]`)
		}
		if(!suppressGeneralLog) {
			// TODO write to local log table
		}
	}
}
